module.exports = __webpack_public_path__ + "img/theme4.b2d96678.png";